import React from 'react';
import { accountMenu } from '@v2/shared/Layouts/Account/menu';
import { AccountLayoutProps } from '@v2/shared/lib/types';
import SideMenuLayout from '../SideMenu';

/**
 * The shell the signed-in customer's pages share, in DiscountMags' chrome.
 *
 * The Institutional layout's sibling: the same SideMenuLayout with a different list in
 * it. A page that wants it says `Page.layoutName = 'Layouts.Account'` and nothing else,
 * and draws its own breadcrumb.
 *
 * TopMags has its own file of the same name, taking the same props, resolved by brand
 * the way `Layouts.Full` already is. The menu and the rail are shared between the two;
 * what is here is the chrome.
 */
export default function Account({
  children,
  autoRenewServiceName,
  autoRenewUrl,
  ...props
}: AccountLayoutProps) {
  return (
    <SideMenuLayout
      label="Account"
      groups={accountMenu({ autoRenewServiceName, autoRenewUrl, digitalLibrary: true })}
      {...props}
    >
      {children}
    </SideMenuLayout>
  );
}
